
import React, { useEffect, useState } from 'react';
import "./skillTrajectory.css";


const SkillTrajectory = (props) => {
    //to do find alternative to process.env.REACT_APP_USERACTIVITYAPIURL sanitize for URl
    const skillTrajectoryUrl = new URL(process.env.REACT_APP_USERACTIVITYAPIURL + "UserReflection/");
    const [iframeUrl, setIframeUrl] = useState(`/tool/index.html?offeringID=${props.offeringId}&userID=${props.email}&apiURL=${skillTrajectoryUrl}`);
    const [iframeLoader, setIframeLoader] = useState(true);
    // var settingWidth = window.innerWidth;
    // var settingHeight = window.innerHeight;
    // function appWidthHeightRatio() {
    //     return Number(settingWidth / settingHeight);
    // }
    // function resize() {
    //     let calculatedHeight = 0;
    //     let calculatedWidth = 0;
    //     let appView = document.getElementById('app-view');
    //     appView.style.width = settingWidth + 'px';
    //     appView.style.height = settingHeight + 'px';

    //     if (document.body.clientWidth < document.body.clientHeight) {
    //         calculatedWidth = document.body.clientWidth;
    //         calculatedHeight = document.body.clientWidth / appWidthHeightRatio();
    //         if (calculatedHeight > document.body.clientHeight) {
    //             calculatedWidth = appWidthHeightRatio() * document.body.clientHeight;
    //             calculatedHeight = document.body.clientHeight;
    //         }
    //     } else {
    //         calculatedHeight = document.body.clientHeight;
    //         calculatedWidth = appWidthHeightRatio() * document.body.clientHeight;
    //         if (calculatedWidth > document.body.clientWidth) {
    //             calculatedHeight = document.body.clientWidth / appWidthHeightRatio();
    //             calculatedWidth = document.body.clientWidth;
    //         }
    //     }

    //     if (
    //         (calculatedWidth > settingWidth ||
    //             calculatedHeight > settingHeight) &&
    //         !false
    //     ) {
    //         calculatedWidth = settingWidth;
    //         calculatedHeight = settingHeight;
    //     }
    //     var scaleX = Number(calculatedWidth / settingWidth);
    //     var scaleY = Number(calculatedHeight / settingHeight);
    //     appView.style.transform = 'scale(' + scaleX + ',' + scaleY + ')';
    //     appView.style.left =
    //         (document.body.clientWidth - calculatedWidth) / 2 + 'px';
    //     appView.style.top =
    //         (document.body.clientHeight - calculatedHeight) / 2 + 'px';
    // }
    //  window.onresize = resize;

    useEffect(() => {
        //   resize();
    }, []);

    const CDx = {};

    const exitSkillTrajectory = () => {
        props.closeSkillTrajectory();
    };

    const selfReflectionToolUrl = () => {
        return new Promise(function (resolve, reject) {

            let url = skillTrajectoryUrl;
            if (url);
            else {
                url = "ERROR: Unable to fetch url, Please try again.";
            }
            resolve(url);
        })
    }

    CDx.exitSkillTrajectory = exitSkillTrajectory;
    CDx.selfReflectionToolUrl = selfReflectionToolUrl;

    window.getCDx = () => { return CDx; };
    window.CDx = CDx;


    return (
        <div className={`app-view-wrapper ${props.showSkillTrajectory ? "" : "hide-skilltrajectory"}`}>
            <div className="app-view">
                {/* <button className="apply-btn cdx-btn sr_register_btn" onClick={props.closeSkillTrajectory}>Register</button> */}
                {iframeLoader && <div className="skillTrajectoryLoader"><div>Loading Self Reflection exercise, please wait...</div></div>}
                <iframe title="Inline Frame Example"
                    className="iframe"
                    src={iframeUrl}
                    width="100%"
                    height="100%"
                    onLoad={() => { setIframeLoader(false); }}></iframe>
            </div>
        </div >
    );
};

export default SkillTrajectory;